import { ActionTree } from 'vuex';
import axios from 'axios';
import { AdminState } from './types';
import { RootState } from '../types';
import Vue from 'vue'
import { router } from "../../main";

export const actions: ActionTree<AdminState, RootState> = {

    async init(context) {
        
     
        context.commit('SET_DATABASESTATUS', 2, { root: true });
        context.commit('SET_DEBUG', true, { root: true });
    },

    async fetchUsers(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/users').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_USERS', response.data);
            context.dispatch('setSelectedUser', null);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },

    async fetchUserAccess(context, userId) {
        if (!userId) {
            context.commit('SET_USERACCESS', null);
            return;
        }
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.get('/api/admin/users/' + userId + '/access').then(response => {
            context.commit('SET_USERACCESS', response.data);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_USERACCESS', null);
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchScenarioStatus(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/scenarioStatus').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_SCENARIOSTATUS', response.data);
            
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },

    async fetchLogins(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/logins').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_LOGINS', response.data);
           
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },

    async syncLogins(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.put('/api/admin/logins').then(async () => {
            context.dispatch('fetchUsers', null);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },
    async deleteLogin(context, id) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.delete('/api/admin/logins/' + id).then(async () => {
            context.commit('REMOVE_LOGIN', id);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },

    async addLogin(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.post('/api/admin/logins/',context.state.loginEditing).then(response => {
            context.commit('SET_LOGINEDITING', response.data);
            context.dispatch('fetchLogins', null);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        })
    },


    async newLogin(context) {
        context.commit('SET_LOGINEDITING', {
            displayName: '',
            email: '',
        });
    },



    async fetchModels(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/models').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_MODELS', response.data);
            context.dispatch('setSelectedModel', null);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true })
        });
        context.dispatch('fetchModelRoles');
    },

    async fetchModelRoles(context) {
        axios.get('/api/admin/modelroles').then(response => {
            context.commit('SET_MODELROLES', response.data);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async setSelectedUser(context, selectedUser) {
        context.commit('SET_SELECTEDUSER', selectedUser);
    },

    async setSelectedModel(context, selectedModel) {
        context.commit('SET_SELECTEDMODEL', selectedModel);
        if (selectedModel == null) {
            context.commit('SET_MODELGROUPS', null);
        } else {
            context.dispatch('fetchModelGroups', selectedModel.id);
        }
    },


    async setSelectedScenario(context, selectedScenario) {
        context.commit('SET_SELECTEDSCENARIO', selectedScenario);
        
    },


    async fetchGroups(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/groups').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_GROUPS', response.data);
            context.dispatch('setSelectedGroup', null);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async closeAdminDialog(context) {
        context.dispatch('setSelectedGroup', null);
        context.dispatch('setSelectedModel', null);
        context.dispatch('setSelectedRole', null);
        context.commit('SET_ISADDINGLOGIN', false);
    },

    async setIsAddingLogin(context, value: boolean) {
        context.commit('SET_ISADDINGLOGIN', value);
        if (value) context.dispatch('newLogin');
    },

    async setIsAddingGroup(context, value: boolean) {
        context.commit('SET_ISADDINGGROUP', value);
        if (value) context.commit('SET_SELECTEDGROUP', null);
    },

    async setSelectedGroup(context, selectedGroup) {
        context.commit('SET_ISADDINGGROUP', false);
        context.commit('SET_SELECTEDGROUP', selectedGroup);
        if (selectedGroup == null) {
            context.commit('SET_GROUPUSERS', null);
        } else {
            context.dispatch('fetchGroupUsers', selectedGroup.id);
        }
    },

    async fetchGroupUsers(context, groupId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/groups/' + groupId + '/users').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_GROUPUSERS', response.data);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async saveSelectedGroup(context) {
        await axios.put('/api/admin/groups', { group: context.state.selectedGroup, users: context.state.groupUsers }).then(async () => {
            context.dispatch('fetchGroupUsers', context.state.selectedGroup.id);
            context.dispatch('fetchGroups');
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async deleteGroup(context, groupId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.delete('/api/admin/groups/' + groupId).then(() => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.dispatch('setSelectedGroup', null);
            context.dispatch('fetchGroups');
        }).catch((error) => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async createGroup(context, name) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.post('/api/admin/groups', { id: 0, name }).then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.dispatch('fetchGroups').then(() => {
                context.dispatch('setSelectedGroup', response.data);
            });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchModelGroups(context, modelId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/modelgroups/' + modelId).then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_MODELGROUPS', response.data);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async saveModelAll(context) {
        await axios.put('/api/admin/modelgroups', { model: context.state.selectedModel, groups: context.state.modelGroups }).then(async () => {
            context.dispatch('fetchModelGroups', context.state.selectedModel.id);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async saveModelGroups(context) {
        await axios.put('/api/admin/modelgroups', { model: context.state.selectedModel, groups: context.state.modelGroups }).then(async () => {
            context.dispatch('fetchModelGroups', context.state.selectedModel.id);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchGlobalRoles(context) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/globalroles').then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_GLOBALROLES', response.data);
            context.dispatch('setSelectedRole', null);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async setSelectedRole(context, selectedRole) {
        context.commit('SET_SELECTEDROLE', selectedRole);
        if (selectedRole == null) {
            context.commit('SET_ROLEGROUPS', []);
            context.commit('SET_ROLEMODELGROUPS', []);
        } else if (selectedRole.isGlobal) {
            context.dispatch('fetchRoleGroups', selectedRole.id);
        } else {
            context.dispatch('fetchRoleModelGroups', selectedRole.id);
        }
    },


    async fetchRoleGroups(context, roleId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/rolegroups/' + roleId).then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_ROLEGROUPS', response.data);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchRoleModelGroups(context, roleId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        axios.get('/api/admin/rolemodelgroups/' + roleId).then(response => {
            context.commit('SET_ENDBUSY', null, { root: true });
            context.commit('SET_ROLEMODELGROUPS', response.data);
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async saveRoleAll(context) {
        await axios.put('/api/admin/rolegroups', { role: context.state.selectedRole, groups: context.state.roleGroups }).then(async () => {
            context.dispatch('fetchRoleGroups', context.state.selectedRole.id);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        });
    },


    async fetchUsageStats(context, { groupIds, from, to, modelIds, userIds }: { groupIds: number[], from: string, to: string, modelIds?: number[] | null, userIds?: string[] | null }) {
        if (!groupIds || groupIds.length === 0 || !from || !to) {
            context.commit('SET_USAGESTATS', null);
            return;
        }
        const parts: string[] = [
            'from=' + encodeURIComponent(from),
            'to=' + encodeURIComponent(to),
        ];
        groupIds.forEach(id => parts.push('groupIds=' + encodeURIComponent(id)));
        if (modelIds && modelIds.length > 0) {
            modelIds.forEach(id => parts.push('modelIds=' + encodeURIComponent(id)));
        }
        if (userIds && userIds.length > 0) {
            userIds.forEach(id => parts.push('userIds=' + encodeURIComponent(id)));
        }
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.get('/api/admin/usage?' + parts.join('&')).then(response => {
            context.commit('SET_USAGESTATS', response.data);
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_USAGESTATS', null);
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchUsageUsers(context, groupIds: number[]) {
        if (!groupIds || groupIds.length === 0) {
            context.commit('SET_USAGEUSERS', []);
            return;
        }
        const parts = groupIds.map(id => 'groupIds=' + encodeURIComponent(id));
        await axios.get('/api/admin/usage-users?' + parts.join('&')).then(response => {
            context.commit('SET_USAGEUSERS', response.data);
        }).catch((error) => {
            context.commit('SET_USAGEUSERS', []);
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async fetchUsageModels(context, groupIds: number[]) {
        if (!groupIds || groupIds.length === 0) {
            context.commit('SET_USAGEMODELS', []);
            return;
        }
        const parts = groupIds.map(id => 'groupIds=' + encodeURIComponent(id));
        await axios.get('/api/admin/usage-models?' + parts.join('&')).then(response => {
            context.commit('SET_USAGEMODELS', response.data);
        }).catch((error) => {
            context.commit('SET_USAGEMODELS', []);
            context.commit('SET_ERROR', error, { root: true });
        });
    },

    async calculateUnprocessedScenarios(context, modelId) {
        context.commit('SET_STARTBUSY', null, { root: true });
        await axios.put('/api/admin/' + modelId + '/start-processing-unprocessed').then(function () {
            context.dispatch('fetchScenarioStatus');
            context.commit('SET_ENDBUSY', null, { root: true });
        }).catch((error) => {
            context.commit('SET_ERROR', error, { root: true });
        })
    },
};
